import { Component } from 'react'
import { observer } from 'mobx-react'
import truncate from 'lodash.truncate'
import DOMPurify from 'dompurify'

import * as h from 'h'

import { urlEncodeName } from 'utils'

import Card from 'components/Card'

import ProjectModel from 'models/ProjectModel'
import ResourceModel from 'models/ResourceModel'

import styles from './styles.scss'

// This is loosely based off of the ResultBox component. See that component for
// more details on what is happening with the "default" and "adapters" part of
// this component.

const adapters = [
  [
    ProjectModel,
    project => {
      const { name, image, type, subtype, descShort, highlight } = project
      const finalImageUrl = image && (image.tile || image.main || image.details)
      return {
        title: name,
        slug: type.slug,
        meta: ['Explore', subtype.name],
        image: finalImageUrl,
        content: descShort,
        highlight: {
          title: highlight.name,
          content: highlight.desc_short
        }
      }
    }
  ],
  [
    ResourceModel,
    resource => {
      const { name, image, category, subCategory, descShort, highlight } = resource
      const finalImageUrl = image && (image.tile || image.main || image.details)

      return {
        title: name,
        slug: 'resource',
        meta: [category.name, subCategory.name],
        origin: `/${category.slug}?subCategories=${subCategory.slug}`,
        image: finalImageUrl,
        content: descShort,
        highlight: {
          title: highlight.name,
          content: highlight.desc_short
        }
      }
    }
  ]
]

@observer
export default class ResultListItem extends Component {
  adapt (element) {
    // find the appropriate adapter for this element
    for (let matcher of adapters) {
      const [ model, adapter ] = matcher

      if (element instanceof model) {
        return adapter(this.props.element)
      }
    }
  }

  sanitizeHighlightFragment (frag) {
    return DOMPurify.sanitize(frag, {
      ALLOWED_TAGS: [ '#text' ],
      ADD_TAGS: [ 'eshighlight' ]
    })
  }

  render () {
    const { element } = this.props
    const adapted = this.adapt(element)
    const { image, meta, origin, slug, highlight } = adapted

    const title = highlight.title ? highlight.title[0] : adapted.title

    let content = highlight.content
      ? '... ' + highlight.content.map(this.sanitizeHighlightFragment).join(' ... ') + '...'
      : this.sanitizeHighlightFragment(adapted.content)

    content = content.replace(/eshighlight/g, 'strong')

    const previewContent = DOMPurify.sanitize(truncate(content, {
      length: 600,
      separator: /,? +/
    }))

    // Only ID used to fetch element; name at end just for prettiness.
    const sharableLink = `/${adapted.slug}/${element.id}/${urlEncodeName(element.name)}`

    return h.h(Card, {
      title: h.raw({ element: 'span', content: title }),
      altTitle: title,
      link: sharableLink,
      imageUrl: image,
      labelButtons: [meta, origin, slug],
      content: h.raw({ content: previewContent }),
      theme: {
        title: styles.title,
        meta: styles.meta
      }
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/ResultListItem/index.js